module.exports = __webpack_public_path__ + "img/uk_success_5.9a93f953.png";